module.exports = __webpack_public_path__ + "static/media/bimetalica-01.39921fe9.png";